import { useState, useEffect } from "react";
import {
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardTitle,
	IonCol,
	IonButton,
	useIonAlert
} from "@ionic/react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useStore from "../store/store";
import PropertyListItemRentingDetails from "./PropertyListItemRentingDetails";

function PropertyListItem({ elem, reload }: any) {
	const { t } = useTranslation();
	const history = useHistory();
	const [presentAlert] = useIonAlert();
	const { token } = useStore(state => state);
	const [data, setData] = useState<any>(null);

	useEffect(() => {
		getData();
	}, [elem]);

	const getData = async () => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/transactions/stats/${elem?._id}`,
				{},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => setData(res.data))
			.catch(err => console.log(err));
	};

	const handleEdit = (id: string) => history.push(`/properties/u/${id}`);
	const seeDetails = (id: string) => history.push(`/property/${id}`);
	const handleStartRenting = (id: any) => history.push(`/renting/${id}`);
	const handleStopRenting = (id: any) => {
		presentAlert({
			header: `${t("sure")}`,
			buttons: [
				{
					text: `${t("cancel")}`,
					role: "cancel"
				},
				{
					text: `${t("yes")}`,
					role: "confirm",
					handler: () => {
						axios
							.put(
								`${process.env.REACT_APP_API_URL}/properties/stop/${id}`,
								{},
								{ headers: { rentapp_auth: token } }
							)
							.then(res => reload());
					}
				}
			]
		});
	};

	return (
		<IonCol size-xs="12" size-sm="12" size-md="6" key={elem?._id}>
			<IonCard color="light">
				<IonCardHeader
					title={t("clickToSeeDetails") || ""}
					style={{ cursor: "pointer" }}
					onClick={() => seeDetails(elem?._id)}
				>
					<IonCardTitle
						style={{
							fontSize: 18,
							fontWeight: "bold"
						}}
					>
						{elem?.address}
						{elem?.city.length > 0 ? `, ${elem?.city}` : ""}
						{elem?.zip.length > 0 ? `, ${elem?.zip}` : ""}
						{elem?.state.length > 0 ? `, ${elem?.state}` : ""}
					</IonCardTitle>
				</IonCardHeader>
				<IonCardContent
					title={t("clickToSeeDetails") || ""}
					style={{
						paddingBottom: 0
					}}
				>
					<PropertyListItemRentingDetails elem={elem} data={data} />
				</IonCardContent>
				<div>
					<IonButton
						fill="clear"
						color="dark"
						onClick={() => handleEdit(elem?._id)}
					>
						{t("edit")}
					</IonButton>
					{elem?.status === "vacant" && (
						<IonButton
							fill="clear"
							color="primary"
							onClick={() => handleStartRenting(elem?._id)}
						>
							{t("startRenting")}
						</IonButton>
					)}
					{elem?.status === "occupied" && (
						<IonButton
							fill="clear"
							color="danger"
							onClick={() => handleStopRenting(elem?._id)}
						>
							{t("stopRenting")}
						</IonButton>
					)}
				</div>
			</IonCard>
		</IonCol>
	);
}

export default PropertyListItem;
